__turbopack_context__.v({
  "action_loading": "ways-of-contact-module__FpYLUG__action_loading",
  "action_spinner": "ways-of-contact-module__FpYLUG__action_spinner",
  "actions": "ways-of-contact-module__FpYLUG__actions",
  "contact_container": "ways-of-contact-module__FpYLUG__contact_container",
  "contact_content": "ways-of-contact-module__FpYLUG__contact_content",
  "whatsapp-button-spinner": "ways-of-contact-module__FpYLUG__whatsapp-button-spinner",
  "whatsapp_message_instructions": "ways-of-contact-module__FpYLUG__whatsapp_message_instructions",
});
